import { render, staticRenderFns } from "./channelsTable.vue?vue&type=template&id=279068e2&scoped=true&"
import script from "./channelsTable.vue?vue&type=script&lang=js&"
export * from "./channelsTable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/bs-helpers.css?vue&type=style&index=0&id=279068e2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279068e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
